<template>
	<page class="dashboard" title="Klienter" style="background-color: #F0F0F0;">
		<input class="tool-text" placeholder="Søg" type="text" slot="tools" v-model="search" />
		<button-view style="float: left;" slot="tools" @click="createClient">+ Klient</button-view>
		<new-table-view class="list" @itemClick="itemClick" :columns="[
			{
				label: 'ID',
				name: 'id'
			},
			{
				label: 'Sidste pakke',
				name: 'last_message',
				filter: 'timestamp'
			},
			{
				label: 'Version',
				name: 'current_version'
			},
			{
				label: 'Opdater til',
				name: 'update_version'
			},
			{
				label: 'Note',
				name: 'note'
			},
			{
				label: 'E-mail',
				name: 'email'
			},
			{
				label: '',
				name: 'context',
				align: 'right',
				template: {
					name: 'button',
					label: 'Publiser'
				},
				weight: '130px'
			},
			{
				label: '',
				name: 'delete',
				align: 'right',
				template: {
					name: 'button',
					label: 'Slet'
				},
				weight: '100px'
			}
		]" :items="_items" @context="itemContext" @delete="itemDelete" />
	</page>
</template>

<script>
	import { bus } from '../../bus'

	import ContextPopupView from '../views/ContextPopupView';

	const protocol = require('../../protocol');

	import client from '../model/client';

    export default {
		data() {
			return {
				search: '',
				items: []
			};
		},
		components: {

		},
		watch: {

		},
		computed: {
			_items() {
				const self = this;

				return this.search == '' ? this.items : this.items.filter((item) => {
					const buffer = item.id + item.current_version + item.update_version + (item.note === null ? '' : item.note.toString().toLowerCase()) + (item.email === null ? '' : item.email.toString().toLowerCase());
					return buffer.indexOf(self.search) > -1;
				});
			}
		},
		methods: {
			createClient() {
				console.log("create client");

				const self = this;

				client.open(null, () => {
					self.update();
				});
			},
			async itemDelete(item, event) {
				event.stopPropagation();
				console.log('item delete', item);

				if (confirm('Sikker?')) {
					await this.axios.delete(`/clients/${item.id}`);
					this.update();
				}
			},
			createAction(item, template) {
				const self = this;

				return {
					label: template.label,
					action: async function () {
						//window.open(process.env.VUE_APP_API + '/planning/tasks/' + item.id + '/private/print/?token=' + self.$store.state.auth);
						client.send({
							id: item.id,
							topic: `clients/${item.id}`,
							tmpl: template.tmpl
						}, async (model) => {
							await self.axios.post('/publish', {
								topic: model.topic,
								payload: model.tmpl
							});

							return true;
						});
					}
				};
			},
			itemContext(item, event) {
				event.stopPropagation();
				console.log('context', item);

				var actions = [];

				for (var i = 0; i < protocol.length; ++i) {
					console.log('prot', protocol[i]);
					actions.push(this.createAction(item, protocol[i]));
				}

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					actions: actions
				});
			},
			async itemClick(item) {
				console.log('item click', item);
				const self = this;

				client.open(item.id, () => {
					self.update();
				});
			},
			async update() {
				this.items = (await this.axios.get('/clients')).data;
			}
		},
		mounted() {
			this.update();

			var self = this;

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				self.items = null;
			});
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss" scoped>
	.tool-text {
		display: block;
		float: left;
		margin-left: 10px;
		height: 40px;
		border-radius: 20px;
		padding-left: 20px;
		border: 1px solid #cecece;
	}

	.layout {
		width: 100%;
		height: 100%;
		display: grid;
		grid-template-columns: 320px 1fr;
		grid-template-rows: 290px 1fr;

		& > .new-table-view {
			width: 100%;
			height: 100%;
		}
	}

	.date {
		grid-column: 1;
		grid-row: 1;
		background-color: #f0f0f0;
		padding: 30px;
	}

	.tasks {
		grid-column: 1;
		grid-row: 2 / 3;
		background-color: #f0f0f0;		
	}

	.list {
		width: 100%;
		height: 100%;
		border-left: 1px solid #cecece;
		background-color: white;
	}
</style>